import type { DirectedTripleWithFilters, Path } from '@ardoq/api-types';

const toTripleKey = ({
  sourceType,
  referenceType,
  targetType,
  direction,
}: DirectedTripleWithFilters): string =>
  [sourceType, referenceType, targetType, direction].join('|');

const toPrefixKeys = (path: Path): string[] =>
  path.map((_, index) =>
    path
      .slice(0, index + 1)
      .map(toTripleKey)
      .join('>')
  );

export const countTraversalHops = (paths: Path[]): number =>
  new Set(paths.flatMap(toPrefixKeys)).size;
